import React from 'react';
import createReactClass from 'create-react-class';
import AddStorageLocation from './AddStorageLocation';
import StorageLocationList from './StorageLocationList';
import setViewTitle from '../../helpers/setViewTitle';
import NeedsClaim from '../common/NeedsClaim';
import storagelocationConfig from './config/storagelocationConfig';
import request from '../../helpers/request';

var StorageLocationListContainer = createReactClass({

  getInitialState() {
    return {
      storageLocations: []
    };
  },

  componentWillMount() {
    setViewTitle('Lagerorte');
  },

  componentDidMount() {
    this._loadStorageLocations();
  },

  newStorageLocationAdded() {
    this._loadStorageLocations();
  },

  _loadStorageLocations() {
    request.get({
      url: storagelocationConfig.apiUrl,
      success: data => {
        if (this.isMounted()) {
          this.setState({
            storageLocations: data
          });
        }
      }
    });
  },

  render() {
    return (
      <div>
        <NeedsClaim claim="vendors:write">
          <AddStorageLocation newStorageLocationAdded={this.newStorageLocationAdded} />
          <br />
        </NeedsClaim>

        <StorageLocationList storageLocations={this.state.storageLocations} />
      </div>
    );
  }

});

export default StorageLocationListContainer;



// WEBPACK FOOTER //
// ./src/components/storagelocations/StorageLocationListContainer.js